import axios from "axios";
import { API_ROOT } from "../constants";
import { errorResponse } from "../helpers";

export const GET_AFFILIATE_ACCOUNT_START = "GET_AFFILIATE_ACCOUNT_START";
export const GET_AFFILIATE_ACCOUNT_SUCCESS = "GET_AFFILIATE_ACCOUNT_SUCCESS";
export const GET_AFFILIATE_ACCOUNT_FAIL = "GET_AFFILIATE_ACCOUNT_FAIL";

export const GET_AFFILIATE_INTRODUCTIONS_START = "GET_AFFILIATE_INTRODUCTIONS_START";
export const GET_AFFILIATE_INTRODUCTIONS_SUCCESS = "GET_AFFILIATE_INTRODUCTIONS_SUCCESS";
export const GET_AFFILIATE_INTRODUCTIONS_FAIL = "GET_AFFILIATE_INTRODUCTIONS_FAIL";

export function getAffiliateAccount() {
	return function (dispatch, getState) {
		dispatch({
			type: GET_AFFILIATE_ACCOUNT_START
		});

		// Get the current token.
		const { session: { token } } = getState();

		axios.get(`${API_ROOT}/affiliate-accounts/mine`, {
			headers: token ? {
				Authorization: `Bearer ${token}`
			} : null,
		}).then(res => res.data).then(affiliateAccount => {
			if (!affiliateAccount) throw new Error("account not found.");
			dispatch({
				type: GET_AFFILIATE_ACCOUNT_SUCCESS,
				affiliateAccount
			});
		}).catch(error => {
			dispatch({
				type: GET_AFFILIATE_ACCOUNT_FAIL,
				error: errorResponse(error)
			});
		})
	}
}

export function getAffiliateIntroductions() {
	return function (dispatch, getState) {
		dispatch({
			type: GET_AFFILIATE_INTRODUCTIONS_START,
		});

		// Get the current token.
		const { session: { token } } = getState();

		axios.get(`${API_ROOT}/affiliate-accounts/introductions`, {
			headers: token ? {
				Authorization: `Bearer ${token}`
			} : null,
		}).then(res => res.data).then(introductions => {
			dispatch({
				type: GET_AFFILIATE_INTRODUCTIONS_SUCCESS,
				introductions
			});
		}).catch(error => {
			dispatch({
				type: GET_AFFILIATE_INTRODUCTIONS_FAIL,
				error: errorResponse(error)
			});
		});
	}
}
